import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HelperService } from '../../../services';
import { Router } from '@angular/router';
import { StorageUtil, AppState, AppFields, AppTypes } from '../../../store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-college-list-grid',
  templateUrl: './college-list-grid.component.html',
  styleUrls: ['./college-list-grid.component.css']
})
export class CollegeListGridComponent implements OnInit {

  public playerID;
  public itemsPerPage = 25;
  public p = 1;
  public selectedRecordIndex = [];
  public collegeAndProgramIDList: any[] = [];
  public isSelectAllCheckBox = false;
  public NoOfSelectedColleges: number;

  @Input() collegeList = [];
  @Input() collegeProgramIDList = [];
  @Input() collegeListCounts: number;
  @Input() gridTitle: string;
  @Input() selectedRecordsCounts: number;

  @Output() selectedColleges: EventEmitter<any[]> = new EventEmitter();
  @Output() selectedCollegeAndProgramIDList: EventEmitter<any[]> = new EventEmitter();

  constructor(
    private helperService: HelperService,
    private router: Router,
    private store: Store<AppState>
  ) { }

  ngOnInit() {
    this.playerID = localStorage.getItem('playerID');
  }

  getFeeInFormat(fee) {
    if (fee != null && fee != '') {
      fee = fee.split('/r').join('/');
      fee = fee.replace(/\/r/g, '');
      fee = fee.replace(/\D/g, '');
    }
    return fee;
  }

  selectedRecord(cid, cpid, e) {
    if (this.selectedRecordsCounts == 0) {
      this.selectedRecordIndex = [];
      this.collegeAndProgramIDList = [];
    }

    var obj = {
      collegeID: cid,
      collegeProgramID: cpid
    }

    if (e.target.checked) {
      this.selectedRecordIndex.push(cid);
      this.collegeAndProgramIDList.push(obj);
    } else {
      this.selectedRecordIndex.splice(this.selectedRecordIndex.indexOf(cid), 1);
      this.collegeAndProgramIDList.splice(this.collegeAndProgramIDList.indexOf(obj), 1);
    }
    // For enable status/delete button and Send Back to Parent Component.
    this.selectedColleges.emit(this.selectedRecordIndex);
    //console.log("collegeAndProgramIDList =>", this.collegeAndProgramIDList);
    this.selectedCollegeAndProgramIDList.emit(this.collegeAndProgramIDList);
  }

  selectAll() {
    this.selectedRecordIndex.length = 0;
    this.collegeAndProgramIDList.length = 0;
    if (this.isSelectAllCheckBox) {
      this.isSelectAllCheckBox = false;
    } else {
      this.isSelectAllCheckBox = true;
      const l = this.collegeList.length;
      for (let i = 0; i < l; i++) {
        var obj = {
          collegeID: this.collegeList[i].collegeID,
          collegeProgramID: this.collegeList[i].collegeprogramID
        }
        this.selectedRecordIndex.push(this.collegeList[i].collegeID);
        this.collegeAndProgramIDList.push(obj);
      }
    }
    this.NoOfSelectedColleges = this.selectedRecordIndex.length;
    this.selectedColleges.emit(this.selectedRecordIndex);
    this.selectedCollegeAndProgramIDList.emit(this.collegeAndProgramIDList);
  }

  setLogo(url) {
    return this.helperService.setCollegeLogo(url);
  }

  starCounter(n: number) {
    return this.helperService.starCounter(n);
  }

  nullStarCounter(n: number) {
    return this.helperService.nullStarCounter(n);
  }

  redirectToCollegeDashboard(collegeID, collegeprogramID) {
    this.store.dispatch({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.GetCollegeLeftNavCounts]: null
      }
    })

    this.store.dispatch({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.GetCollegeDetails]: null
      }
    })

    this.store.dispatch({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.GetPlayerAttendingThisCollegeData]: null
      }
    })
    this.router.navigate(['/college-recruiting/colleges/dashboard/' + collegeID + '/' + collegeprogramID]);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/college-list-grid/college-list-grid.component.ts